import { falAngleRight } from 'shared/@generated/icons/falAngleRight';
import { useTranslation } from 'react-i18next';
import { Animal, Listing, Props } from 'shared/@types';
import BookInsuranceCall from 'shared/components/lazy-book-insurance-call';
import { Button } from 'shared/components/button';
import { FullscreenModal } from 'shared/components/fullscreen-modal';

import { getPetInsuranceWidgetAnalyticsParams } from 'shared/components/pet-insurance-widget-analytics';
import { analytics } from 'shared/library/analytics';

export const BookInsuranceCallModal = ({
  animal,
  widgetAnalyticsParams,
}: Props<{
  animal: Listing['animal'];
  widgetAnalyticsParams: ReturnType<typeof getPetInsuranceWidgetAnalyticsParams>;
}>) => {
  const { t } = useTranslation('components');

  return (
    <FullscreenModal
      headerTitle={'Boka ett samtal'}
      description={t('book_insurance_call.description', {
        insurance: t(
          animal === Animal.Dog
            ? 'screens:pet_insurance.dog_insurance'
            : 'screens:pet_insurance.cat_insurance',
        ).toLowerCase(),
      })}
      centered={true}
      scrollable={false}
      contentTestID={'insurance-call-modal'}
      trigger={(modal) => (
        <Button
          text={'Boka ett samtal'}
          icon={falAngleRight}
          color={'brown'}
          testID={'insurance-call-open'}
          onPress={() => {
            analytics.event('widget_book_call', widgetAnalyticsParams);
            modal.open();
          }}
        />
      )}
    >
      <BookInsuranceCall inModal={true} />
    </FullscreenModal>
  );
};
